const returnGoodCN = {
    submitreturnapplication:"提交退货申请",
    goodTitle:"退货商品",
    orderStatus:"订单状态",
    orderAmount:"订单金额",
    selectService:"选择服务",
    submitYourReturnApplication:"提交退货申请",
    refundOnly:"仅退款",
    returnAndRefund:"退货退款",
    changeTheGoods:"我要换货",
}


const returnGoodEN = {
    submitreturnapplication:"Submit return application",
    goodTitle:"Return of the goods",
    orderStatus:"Order status",
    orderAmount:"Order amount",
    selectService:"Select a service",
    SubmitYourReturnApplication:"Submit your return application",
    refundOnly:"Refund only",
    returnAndRefund:"Return and refund",
    changeTheGoods:"Change the goods",
}

const langPackage = {
    cn: returnGoodCN,
    en: returnGoodEN
}

export {langPackage}
